import React from 'react';
import ReactECharts from 'echarts-for-react';

const ConversionFunnel = () => {
  const getOption = () => {
    return {
      title: {
        text: 'Conversion Funnel',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      series: [
        {
          name: 'Funnel',
          type: 'funnel',
          left: '10%',
          top: 60,
          bottom: 60,
          width: '80%',
          min: 0,
          max: 100,
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: {
            show: true,
            position: 'inside'
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: 'solid'
            }
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          emphasis: {
            label: {
              fontSize: 20
            }
          },
          data: [
            { value: 1000, name: 'Emails Sent', itemStyle: { color: '#3B82F6' } },
            { value: 250, name: 'Emails Opened', itemStyle: { color: '#10B981' } },
            { value: 75, name: 'Links Clicked', itemStyle: { color: '#8B5CF6' } },
            { value: 25, name: 'Responses', itemStyle: { color: '#F59E0B' } },
            { value: 8, name: 'Conversions', itemStyle: { color: '#EF4444' } }
          ]
        }
      ]
    };
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <ReactECharts
        option={getOption()}
        style={{ height: '400px' }}
        opts={{ renderer: 'canvas' }}
      />
    </div>
  );
};

export default ConversionFunnel;